import PropTypes from 'prop-types';
import EmergencyStatusReport from './emergency-status-report';

export default PropTypes.shape({
  poi_id: PropTypes.string,
  has_power: EmergencyStatusReport,
  has_gas: EmergencyStatusReport,
  has_diesel: EmergencyStatusReport,
});
